module.exports = __webpack_public_path__ + "static/media/Drag.2046a7be.svg";